module.exports = __webpack_public_path__ + "static/media/hall-P4.dbbc06e8.svg";